import React from 'react';
import CodeIcon from 'components/atoms/icons/code';

import s from './styles.module.scss';

interface IProps {
  code: string;
  name?: string;
}

const CodeCol: React.FC<IProps> = (props) => {
  const { code, name } = props;

  return (
    <span className={s.code}>
      <CodeIcon />
      {code} {name && <span>{name}</span>}
    </span>
  );
};

export default CodeCol;
